import { CustomerAuthInputField } from '../form-sections'
import type { CustomerAuthFieldUiHelpers } from '../form-sections'

type ResetPasswordFormViewProps = {
  password: string
  confirmPassword: string
  submitting: boolean
  formError: string
  loginHref: string
  submitCta: string
  submittingCta: string
  backToLoginLabel: string
  passwordLabel: string
  passwordPlaceholder: string
  passwordShowLabel: string
  passwordHideLabel: string
  confirmPasswordLabel: string
  confirmPasswordPlaceholder: string
  fieldUi: CustomerAuthFieldUiHelpers
  onPasswordChange: (value: string) => void
  onConfirmPasswordChange: (value: string) => void
  onSubmit: () => void
}

export const ResetPasswordFormView = ({
  password,
  confirmPassword,
  submitting,
  formError,
  loginHref,
  submitCta,
  submittingCta,
  backToLoginLabel,
  passwordLabel,
  passwordPlaceholder,
  passwordShowLabel,
  passwordHideLabel,
  confirmPasswordLabel,
  confirmPasswordPlaceholder,
  fieldUi,
  onPasswordChange,
  onConfirmPasswordChange,
  onSubmit,
}: ResetPasswordFormViewProps) => (
  <form
    className="space-y-4"
    onSubmit={(event) => {
      event.preventDefault()
      void onSubmit()
    }}
  >
    <CustomerAuthInputField
      field="password"
      label={passwordLabel}
      type="password"
      value={password}
      onChange={onPasswordChange}
      placeholder={passwordPlaceholder}
      autoComplete="new-password"
      required
      disabled={submitting}
      allowPasswordToggle
      showPasswordLabel={passwordShowLabel}
      hidePasswordLabel={passwordHideLabel}
      ui={fieldUi}
    />

    <CustomerAuthInputField
      field="confirmPassword"
      label={confirmPasswordLabel}
      type="password"
      value={confirmPassword}
      onChange={onConfirmPasswordChange}
      placeholder={confirmPasswordPlaceholder}
      autoComplete="new-password"
      required
      disabled={submitting}
      allowPasswordToggle
      showPasswordLabel={passwordShowLabel}
      hidePasswordLabel={passwordHideLabel}
      ui={fieldUi}
    />

    {formError ? <p className="text-sm leading-relaxed text-(--color-status-error)">{formError}</p> : null}

    <button
      type="submit"
      disabled={submitting}
      className="ca-btn-primary inline-flex h-11 w-full items-center justify-center px-4 text-sm font-semibold shadow-[0_10px_24px_-18px_color-mix(in_srgb,var(--color-action-primary)_85%,transparent)] transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-60"
    >
      {submitting ? submittingCta : submitCta}
    </button>

    <a
      href={loginHref}
      className="inline-flex w-full items-center justify-center text-sm font-semibold text-(--color-focus-ring) underline decoration-[color-mix(in_srgb,var(--color-focus-ring)_35%,transparent)] underline-offset-4 transition-colors duration-150 hover:text-(--color-text-primary)"
    >
      {backToLoginLabel}
    </a>
  </form>
)
